import { useState } from "react";
import { Link } from "react-router-dom";
import resume from "../../files/resume-downloadable.pdf";
import Page from "./Page";

export default function Resume() {
  const [open, setOpen] = useState(false);

  return (
    <Page>
      <div className="resume-container">
        <div className="page-header">
          <Link to={resume} target="_blank" download>
            <h3 className="titleFont">Download PDF</h3>
          </Link>
        </div>
        <div
          className={`resume-stage ${open ? "is-open" : ""}`}
          tabIndex={0}
          onClick={(event) => {
            if (event.target.closest("a")) return;
            setOpen((v) => !v);
          }}
          onKeyDown={(event) => {
            if (event.key === "Enter" || event.key === " ") {
              event.preventDefault();
              setOpen((v) => !v);
            }
          }}
        >
          <p className="resume-hint">Hover / tap to view</p>
          <div className="resume-panel">
            <header className="resume-heading">
              <h1 className="titleFont">Ian Miller</h1>
              <p>Provo, UT</p>
              <p>
                <a href="mailto:the.ianwmiller@gmail.com">
                  the.ianwmiller@gmail.com
                </a>
                {" · "}
                <a
                  href="https://www.linkedin.com/in/ian-miller-a57b87246"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  LinkedIn
                </a>
              </p>
            </header>

            <section>
              <h2 className="titleFont">Summary</h2>
              <p>
                Mid-level Front End Developer with strong full-stack experience
                building scalable, production-grade web applications. Proven
                track record of shipping high-impact features, stabilizing
                complex systems, and improving user-critical flows in various
                fields including healthcare SaaS platforms.
              </p>
            </section>

            <section>
              <h2 className="titleFont">Experience</h2>
              <article>
                <h3>Mid-Level Front End Developer — Shed</h3>
                <p className="resume-meta">
                  Sept 2024 – April 2026 · South Jordan, UT
                </p>
                <ul>
                  <li>
                    Key contributor to scaling Shed’s software for 30,000+
                    monthly subscribers, 30+ new medications, onboarding forms,
                    A/B testing, and new telehealth verticals.
                  </li>
                  <li>
                    Delivered 230+ production issues, including 40+ features and
                    28+ high-priority fixes.
                  </li>
                  <li>
                    Built self-serve appointment scheduling with state,
                    medicine, and health-history rules.
                  </li>
                  <li>
                    Improved reliability around duplicate bookings, billing, and
                    async/state bugs; helped migrate Firebase systems to
                    API-driven architecture.
                  </li>
                  <li>
                    Built and refined onboarding, checkout, and subscription
                    lifecycle UI across product lines.
                  </li>
                  <li>
                    Optimized onboarding to feel more seamless, with fewer
                    bottleneck points in the conversion flow.
                  </li>
                  <li>
                    Restored stability by fixing infinite API calls, broken
                    analytics/data layers, and scheduling/timezone issues.
                  </li>
                  <li>
                    Shipped daily on a production-focused team; used AI tools to
                    speed debugging, tests, and task breakdown.
                  </li>
                </ul>
              </article>
              <article>
                <h3>Full Stack Developer — DevPipeline</h3>
                <p className="resume-meta">April 2022 – Sept 2024 · Orem, UT</p>
                <ul>
                  <li>
                    Built and maintained full-stack apps with React, Flask, and
                    PostgreSQL.
                  </li>
                  <li>
                    Developed scheduling systems, onboarding flows, and dynamic
                    dashboards.
                  </li>
                  <li>
                    Designed flexible database structures and integrated
                    third-party APIs for 100k+ record datasets.
                  </li>
                </ul>
              </article>
              <article>
                <h3>Front End Instructor — DevPipeline</h3>
                <p className="resume-meta">Feb 2023 – 2024 · Orem, UT</p>
                <ul>
                  <li>
                    Taught JavaScript, React, HTML, and CSS with a real-world
                    focus.
                  </li>
                  <li>
                    Mentored 20+ developers on debugging, collaboration, and
                    Agile workflows.
                  </li>
                </ul>
              </article>
            </section>

            <section>
              <h2 className="titleFont">Education</h2>
              <p>
                Full Stack Development Track — DevPipeline · Orem, UT · 2022
              </p>
            </section>

            <section>
              <h2 className="titleFont">Skills</h2>
              <p>
                React, JavaScript, TypeScript, HTML, SCSS, DevOps, Python,
                Flask, SQLAlchemy, REST APIs, JSON/XML, form tools, Stripe,
                Firebase, PostgreSQL, SQL, Git, browser tools
              </p>
            </section>
          </div>
        </div>
      </div>
    </Page>
  );
}
